import { UploadTab } from "@app/shared/components/documentUpload/DocumentsModal/UploadTab";
import {
    NewS3File,
    newS3FileToCreateFileInput,
} from "@app/usecases/FileUseCases";
import { Modal } from "@design-system/Modal";
import { type CreateFileInput } from "@generated/client/graphql";
import { type FC, useState } from "react";
import { useSupplierQuestionnaireUploadDocumentModalTranslations } from "./i18n";

export const UploadDocumentModal: FC<{
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: (files?: CreateFileInput[]) => void;
    loading: boolean;
}> = ({ open, onOpenChange, onConfirm, loading }) => {
    const [newS3Files, setNewS3Files] = useState<NewS3File[]>([]);

    const handleConfirm = async () => {
        onConfirm(newS3Files.map(newS3FileToCreateFileInput));
        setNewS3Files([]);
    };

    const { t, keys } =
        useSupplierQuestionnaireUploadDocumentModalTranslations();

    return (
        <Modal open={open} onOpenChange={onOpenChange}>
            <Modal.Overlay scrollable>
                <Modal.Content>
                    <Modal.Header withClose>
                        <Modal.Title>{t(keys.title)}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <UploadTab
                            newS3Files={newS3Files}
                            setNewS3Files={setNewS3Files}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Modal.CancelCTA>{t(keys.cancel)}</Modal.CancelCTA>
                        <Modal.ConfirmCTA
                            loading={loading}
                            onClick={handleConfirm}
                            preventClose
                        >
                            {t(keys.confirm)}
                        </Modal.ConfirmCTA>
                    </Modal.Footer>
                </Modal.Content>
            </Modal.Overlay>
        </Modal>
    );
};
